import { format, parse } from "date-fns";

const TOLERANCIA_PERCENTUAL = 0.0001;
const REGEX_MES = /^(0[1-9]|1[0-2])$/;
const REGEX_ANO = /^\d{4}$/;

export const formatarData = (value) => {
  if (!value) return "";

  const date =
    typeof value === "string" && value.includes("/")
      ? parse(value, "dd/MM/yyyy", new Date())
      : new Date(value);

  if (Number.isNaN(date.getTime())) return "";

  return format(date, "dd/MM/yyyy");
};

export const formatarValor = (value) =>
  Number(value || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

const splitCompetencia = (competencia = "") => {
  const [mes = "", ano = ""] = String(competencia).split("/");
  return {
    mes_competencia: mes,
    ano_competencia: ano,
  };
};

export const criarDraftItem = (item = {}) => {
  const { mes_competencia, ano_competencia } = splitCompetencia(
    item.competencia
  );
  return {
    mes_competencia,
    ano_competencia,
    porcentagem: item.porcentagem ?? "",
  };
};

export const somarPorcentagens = (competencias) =>
  competencias.reduce(
    (total, item) => total + Number(item.porcentagem || 0),
    0
  );

export const validarCompetencias = (draft) => {
  if (!Array.isArray(draft) || draft.length < 1) {
    return "Adicione pelo menos uma competencia.";
  }

  for (const item of draft) {
    const mes = String(item.mes_competencia || "").trim();
    const ano = String(item.ano_competencia || "").trim();

    if (!REGEX_MES.test(mes) || !REGEX_ANO.test(ano)) {
      return "Competencia invalida. Preencha mes e ano no formato MM e AAAA.";
    }

    const porcentagem = Number(item.porcentagem);
    if (Number.isNaN(porcentagem) || porcentagem <= 0) {
      return "A porcentagem deve ser maior que zero.";
    }
  }

  const soma = somarPorcentagens(draft);
  if (Math.abs(soma - 100) > TOLERANCIA_PERCENTUAL) {
    return "A soma das porcentagens deve ser 100%.";
  }

  return "";
};

export const extrairMensagemErroAPI = (error) => {
  const data = error?.response?.data;
  if (!data) return "Nao foi possivel carregar as competencias da nota.";
  return data.mensagem;
};

export const getComparableValue = (row, field) => {
  if (field === "valor") return Number(row.valor || 0);

  if (field === "data") {
    const raw = row.data;
    if (!raw) return 0;

    const date =
      typeof raw === "string" && raw.includes("/")
        ? parse(raw, "dd/MM/yyyy", new Date())
        : new Date(raw);
    return Number.isNaN(date.getTime()) ? 0 : date.getTime();
  }

  return String(row[field] ?? "").toUpperCase();
};
